export enum WebsocketTypes {
    WS_CONNECT = '@Websocket/WS_CONNECT',
    WS_DISCONNECT = '@Websocket/WS_DISCONNECT',
    WS_MESSAGE = '@Websocket/WS_MESSAGE',
    WS_SEND_MESSAGE = '@Websocket/WS_SEND_MESSAGE',
}